import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import styled from 'styled-components'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import TipTeaser from '../components/TipTeaser'
import CategoryNav from '../components/categoryNav'
import get from 'lodash/get'
import BackgroundImage from '../components/BackgroundImage';
import Pagination from '../components/Pagination'


const options = {
    renderText: text => text.split('\n').flatMap((text, i) => [i > 0 && <br />, text])
};

class CategoryList extends React.Component {

  render() {
    const allContentfulTip = get(this.props, 'data.allContentfulTip.edges');
    const allContentfulCategory = get(this.props, 'data.categories.edges');
    const thisCategory = get(this.props, 'data.thisCategory.edges[0]');
    const { currentPage, numPages, categoryName, description, slug } = this.props.pageContext;
  
    return(
      <Layout>
        <SEO title={`${categoryName} tips`} />

         <BackgroundImage imageData={thisCategory.node.image.fluid} height="300px">
            <Container>
              <h1>All {categoryName} tips</h1>
            </Container>
          </BackgroundImage>

        <Main>

          <Description>
            { documentToReactComponents(description, options) }
          </Description>  

            <CategoryNav data={allContentfulCategory}/>

        </Main>

        <TeaserList>
            {allContentfulTip.map(({ node }) => {
                return (
                    <TeaserListItem key={node.slug}>
                        <TipTeaser tip={node} />
                    </TeaserListItem>
                )
            })}
        </TeaserList>

    <Pagination pages={numPages} current={currentPage} slug={`/tips/category/${slug}`} />
        
    </Layout>
    );

  }

}

export default CategoryList


export const pageQuery = graphql`
  query CategoryListQuery($categoryName: String, $skip: Int!, $limit: Int!) {
    allContentfulTip(
      sort: {fields: createdAt, order: DESC}
      filter: {category: {name: {eq: $categoryName}}}
      limit: $limit
      skip: $skip
      ) {
      edges {
        node {
            slug
            title
            id
            tag
            category {
                name
            }
            timeToRead
            image {
              file {
                url
              }
            fluid(maxWidth: 1400, maxHeight: 900, resizingBehavior: SCALE) {
                    ...GatsbyContentfulFluid
                }
            }
            category {
               name
               slug
             }
          }
        }
      }
      
       
    categories: allContentfulCategory {
        edges {
          node {
            name
            slug
            description {
                json
            }
          }
        }
     }

    thisCategory: allContentfulCategory(filter: {name: {eq: $categoryName}}) {
      edges {
        node {
          name
          image {
            file {
              url
            }
            fluid(maxWidth: 1400, maxHeight: 900, resizingBehavior: SCALE) {
              ...GatsbyContentfulFluid
            }
          }
        }
      } 
     }
  }
`;

const Container = styled.div`
  max-width: 800px;
  width: 100%;
   margin: auto; 
   display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
  padding-bottom: 40px;

  h1 {
    font-size: 30px;
  }

  @media(max-width: 768px) {
    padding-left: 20px;
  }
`;

const TeaserList = styled.ul`
  margin: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  @media(max-width: 500px) {
    flex-direction: column;
  }
`;
const TeaserListItem = styled.li`
  list-style: none;
  flex: 1 0 30%; 
  margin: 10px; 
`;

const Main = styled.div` 
  max-width: 900px;
  margin: 60px auto; 
  color: #fff;

  @media(max-width: 768px) {
    padding: 0 20px;
    margin-top: 0;
  }

  a {
    color: #3c7db6;
    text-decoration: none;
  }
`;

const Description = styled.div`
  text-align: center;
`;

